export default {
  appTitle: 'LoanKnow',
  apiUrl: 'https://api.loanknow.com/api',
  appEnv: 'production',
  isDevelopment: false,
  isStaging: false,
  isProduction: true,
};
